import React from "react"
import SectionHeader from "../../molecules/SectionHeader"
import TabsHorizontal from "../../molecules/TabsHorizontal"
import "./styles.scss"
const OurValues = ({ subtitle, children, title, slides, isDesktop }) => {
  return (
    <section className="section section--ourValues">
      <div className="wrapper--text">
        <SectionHeader
          attributes={{
            "data-sal": "slide-up",
            "data-sal-duration": "1000",
            "data-sal-easing": "ease",
          }}
          type="h2"
          subtitle={subtitle}
        >
          {title}
        </SectionHeader>
        <p className="ourValues__description">{children}</p>
        <TabsHorizontal isDesktop={isDesktop} slides={slides} />
      </div>
    </section>
  )
}

export default OurValues
